import '../Helpers/closestPolyfill';

const OpenClass = 'open';
const OverflowClass = 'overflow-visible';
const HideXOverflow = 'overflow-x-hidden';
export function initializePopups() {

    var tooltips = document.querySelectorAll('[data-tooltip-container]');   

    [].forEach.call(tooltips, (tooltip: HTMLElement) => {
        init(tooltip);
    });
   
}

function init(tooltip: HTMLElement) {
    // Get the message from the data-content element
    let trigger: HTMLElement = tooltip.querySelector('[data-toggletip-trigger]');
    let tableContainer = tooltip.querySelector('[data-tooltip-content-container]');
    let main = document.querySelector('main.main');

    let carousel = tooltip.closest('.swiper-container');
    let activeCarousel = tooltip.closest('.swiper-container-initialized');

    // Toggle the message
    trigger.addEventListener('click', function () {
        if (!tableContainer.classList.contains(OpenClass) && (activeCarousel == null || this.closest('.swiper-slide').classList.contains('swiper-slide-visible'))) {
            open();
        }
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
        if (trigger !== e.target && !trigger.contains(e.target as HTMLElement)) {
            close();
        }
    });

    // Remove toggletip on ESC
    trigger.addEventListener('keydown', function (e) {
        if ((e.keyCode || e.which) === 27) {
            close();
        }
    });

    function open() {
        if (!tableContainer.classList.contains(OpenClass)) {
            tableContainer.classList.add(OpenClass);
            carousel.classList.add(OverflowClass);
            main.classList.add(HideXOverflow);
        }
    }

    function close() {
        if (tableContainer.classList.contains(OpenClass)) {
            tableContainer.classList.remove(OpenClass);
            carousel.classList.remove(OverflowClass);
            main.classList.remove(HideXOverflow);
        }
    }

}

